import {
  DefaultContext,
  DocumentNode,
  OperationVariables
} from "@apollo/client"
import { apolloCubeClient } from "./studyPlanApolloStatic"
import { errorParse } from "./studyPlanGqlErrorParser"

export type GQLApiNamesType = "STUDY_PLAN" | "REPORTING"

export type GQLContextType = { apiName?: GQLApiNamesType } | DefaultContext

// QUERIES
export async function executeQuerySideload(
  gqlQuery: DocumentNode,
  parameterList: OperationVariables,
  context: GQLContextType = {
    apiName: "STUDY_PLAN"
  }
) {
  // const result = await apolloCubeClient.query({
  //   query: gqlQuery,
  //   variables: parameterList,
  //   fetchPolicy: "no-cache" // temporary addition, cache mess up activate plan then refetch
  // })
  // return result?.data

  return (
    apolloCubeClient
      .query({
        query: gqlQuery,
        variables: parameterList,
        context,
        fetchPolicy: "no-cache" // temporary addition, cache mess up activate plan then refetch
      })
      .then(result => {
        return result?.data
      })
      //// only disable to test auth
      .catch(err => {
        throw errorParse(err)
      })
  )
}

export function executeWatchQuerySideload(
  gqlQuery: DocumentNode,
  parameterList: OperationVariables,
  context: GQLContextType = {
    apiName: "STUDY_PLAN"
  }
) {
  return apolloCubeClient.watchQuery({
    query: gqlQuery,
    variables: parameterList,
    context,
    fetchPolicy: "no-cache" // temporary addition, cache mess up activate plan then refetch
  })
}

// MUTATIONS
export async function executeMutationSideload(
  gqlMutation: DocumentNode,
  parameterList: OperationVariables,
  context: GQLContextType = {
    apiName: "STUDY_PLAN"
  }
) {
  return (
    apolloCubeClient
      .mutate({
        mutation: gqlMutation,
        variables: parameterList,
        context
      })
      .then(result => {
        return result?.data
      })
      //// disable catch to test auth
      .catch(err => {
        throw errorParse(err)
      })
  )
}
